import { CanActivateFn } from "@angular/router";
import { injectLocalStorage } from "ngxtension/inject-local-storage";

/**
 * Captures the 'plan' query param and stores it in localStorage.
 * Used for website -> app signup flow where user selects a plan first.
 * Values: starter_monthly, starter_annual, pro_monthly, pro_annual,
 * max_monthly, max_annual (the Stripe lookup_keys — see
 * manage/src/config/subscriptions.ts).
 */
export const capturePlanGuard: CanActivateFn = (route) => {
  // Must call injectLocalStorage at top level (injection context requirement)
  const selectedPlan = injectLocalStorage<string | null>("selectedPlan", { defaultValue: null });

  const plan = route.queryParams["plan"];
  if (plan) {
    selectedPlan.set(plan);
  }
  return true;
};
